<template>
    <div class="warehouseDetail">
        <div class="top-box flex-x-center">{{ data.title }}</div>
        <div class="inner-card" v-for="(item, index) in list" :key="index">
            <div>
                <div class="inner-text" v-if="item.type == 1">{{ item.content.content }}</div>
                <div class="flex flex-end" v-if="item.type == 1">
                    <div class="copy-btn" @click="copyText(item.content.content)">
                        复制文案
                    </div>
                </div>
                <div v-if="item.type == 2">
                    <div class="swipe-box">
                        <van-swipe :autoplay="3000">
                            <van-swipe-item class="flex-x-center" v-for="(image, indexs) in item.content.imageList" :key="indexs" @click="viewImg(item.content.imageList, indexs)">
                                <img class="swipe-img" :src="image.url" alt="" />
                            </van-swipe-item>
                        </van-swipe>
                    </div>
                    <div class="text">长按保存单张图片</div>
                </div>
                <div v-if="item.type == 3" class="wordAndImage" @click="windowOpen(item)">
                    <div>
                        <img :src="item.content.imageList[0].url" alt="">
                        <div class="wordWrapper">
                            <div class="title">{{ item.content.textTitle }}</div>
                            <div class="desc">{{ item.content.textDesc }}</div>
                        </div>
                    </div>
                </div>
                <div class="audioImage" v-if="item.type == 4" @click="windowOpen(item)">
                    <div>
                        <img class="file-icon" alt="" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/media-icon-sck.png">
                        <div class="title flex-1">{{ item.content.audioList[0].name }}</div>
                        <div class="size">文件大小 {{ item.content.audioList[0].sizeDesc }}</div>
                    </div>
                </div>
                <div class="videoWrapper" v-if="item.type == 5" @click="windowOpen(item)">
                    <div class="videoBox">
                        <img class="video-img" :src="item.content.videoPoster" alt="">
                        <img class="player-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/player-icon.png" alt="">
                    </div>
                </div>
                <div v-if="item.type == 6" class="appWrapper">
                    <div class="header">
                        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/logo-sck-xs.png" alt="">
                        <span>美丽田园</span>
                    </div>
                    <div class="Blacks font32">{{ item.content.appTitle }}</div>
                    <div class="mainImg">
                        <img v-for="(item, index) in item.content.imageList" :key="index + 'app_image'" :src="item.url" alt="">
                    </div>
                    <div class="footer">
                        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/wx-link-sck.png" alt="">
                        <span>小程序</span>
                    </div>
                </div>
                <div v-if="item.type == 7" class="filesWrapper" @click="windowOpen(item)">
                    <div>
                        <img src="@/assets/img/files.png" class="file-icon" alt="">
                        <div class="title flex-1">{{ item.content.filesList[0].name }}</div>
                        <div class="size">文件大小 {{ item.content.filesList[0].sizeDesc }}</div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Toast, Lazyload, ImagePreview } from 'vant'
    import { previewFile } from '@/utils/wxCodeAuth'


    export default {
        name: 'blsWarehouseDetail',
        components: {
            ImagePreview
        },
        data() {
            return {
                list: [],
                data: {}
            };
        },
        mounted() {
            // this.title = this.$route.query.title
            // this.data = JSON.parse(this.$route.query.item)
            // if (this.data.type == 1) {
            //     this.text = this.data.content.content
            // } else if (this.data.type == 2) {
            //     this.images = this.data.content.imageList
            // } else if (this.data.type == 4) {
            //     this.audio = this.data.content.audioList[0]
            // } else if (this.data.type == 5) {
            //     this.video = this.data.content.videoList[0]
            //     this.videoPoster = this.data.content.videoPoster
            // } else if (this.data.type == 7) {
            //     this.file = this.data.content.filesList[0]
            // } else if (this.data.type == 3) {
            //     this.news = this.data.content
            // }
            // console.log(this.data);
            let id = this.$route.query.id
            this.init(id)
        },

        methods: {
            init(id) {
                return request({
                    url: `/medium/getMedium?id=${id}`,
                    method: "get",
                }).then((res) => {
                    this.data = res.data
                    this.list = res.data.contentArr
                })
            },
            // 素材预览
            windowOpen(item) {
                switch (item.type) {
                    case 5:
                        this.$router.push({ name: "viewfile", query: { url: item.content.videoList[0].url } });
                        break
                    case 4:
                        this.$router.push({ name: "viewfile", query: { url: item.content.audioList[0].url } });
                        break
                    case 7:
                        previewFile(item.content.filesList[0].url, item.content.filesList[0].name, item.content.filesList[0].size)
                        break
                    case 3:
                        window.location.href = item.content.textUrl
                        break
                }
            },
            copyText(text) {
                this.$copyText(text).then(function (e) {
                    Toast({ position: 'top', message: '复制成功' })
                }, function (e) {
                    Toast({ position: 'top', message: '复制失败' })
                })
            },
            // 查看大图
            viewImg(imgs, index) {
                let imgList = []
                imgs.forEach(element => {
                    imgList.push(element.url)
                });
                ImagePreview({ images: imgList, startPosition: index })
            },
        },
    };
</script>

<style scoped lang="less">
    .text {
        width: 100%;
        font-size: 28px;
        text-align: center;
        color: #a0acb5;
        margin-top: 10px;
    }

    .warehouseDetail {
        height: 100%;
        background-color: #f5f6f7;
        overflow-y: auto;
    }

    .top-box {
        position: relative;
        width: 750px;
        min-height: 102px;
        background: #ffffff;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
        z-index: 99;
        color: #35434c;
        font-size: 34px;
        font-weight: 700;
        text-align: center;
        padding: 15px;
        align-items: center;
    }

    .swipe-box {
        height: 866px;

        .swipe-img {
            width: 559px;
            height: 768px;
            border-radius: 10px;
        }
    }

    .inner-card {
        width: 690px;
        background: #ffffff;
        padding: 30px 30px;
        margin: 50px auto 50px;

        .inner-text {
            color: #35434c;
            font-size: 28px;
            font-weight: 400;
            white-space: pre-wrap;
        }

        .copy-btn {
            width: 167px;
            height: 50px;
            background: rgba(47, 208, 213, 0.2);
            border-radius: 25px;
            border: 2px solid #2fd0d5;
            text-align: center;
            font-size: 24px;
            color: #2fd0d5;
            line-height: 46px;
            margin-top: 30px;
        }
    }

    .audioImage,
    .filesWrapper {
        width: 630px;
        height: 70px;
        padding: 17px 20px;
        border-radius: 4px;
        background: #fafafe;

        div {
            display: flex;
            align-items: center;

            .file-icon {
                width: 34px;
                height: 34px;
                margin-right: 10px;
            }

            .title {
                width: 410px;
                font-size: 24px;
                font-weight: 400;
                color: #4375c9;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }

            .size {
                min-width: 133px;
                font-size: 20px;
                font-weight: 400;
                color: #a0acb5;
            }
        }
    }

    .videoWrapper {
        >div {
            width: 100%;
            height: 560px;
            overflow: hidden;
        }

        .videoBox {
            margin: 0 auto;
            position: relative;
            border-radius: 5px;
            width: 560px;
            height: 560px;

            &::after {
                content: "";
                position: absolute;
                background: #333333;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                opacity: 0.5;
            }

            >span {
                display: inline-block;
                width: 50px;
                height: 50px;
                // background: url("../../../../assets/img/play.png") no-repeat;
                background-size: cover;
                position: absolute;
                z-index: 5000;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            .video-img {
                width: 560px;
                height: 560px;
            }

            .player-icon {
                width: 90px;
                height: 90px;
                position: absolute;
                z-index: 99;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
        }

        video {
            height: 200px;
        }
    }

    .appWrapper {
        width: 466px;
        height: 530px;
        border-radius: 8px;
        box-shadow: 0px 2px 12px 0px rgba(209, 207, 207, 0.32);
        background: #ffffff;
        padding: 24px;

        .header {
            display: flex;
            align-items: center;

            img {
                width: 40px;
                height: 40px;
            }

            span {
                font-size: 24px;
                padding-left: 10px;
                color: #a0acb5;
            }
        }

        .footer {
            display: flex;
            align-items: center;
            padding-top: 7px;
            border-top: 1px solid #d7d7d7;

            img {
                width: 20px;
                height: 20px;
            }

            span {
                font-size: 24px;
                padding-left: 10px;
                color: #35434c;
            }
        }

        .mainImg {
            width: 418px;
            height: 335px;
            margin: 12px 0 20px 0;

            img {
                width: 418px;
                height: 335px;
            }
        }
    }

    .wordAndImage {
        width: 630px;
        height: 107px;
        background: #fafafe;
        border-radius: 4px;
        padding: 18px 20px;

        >div {
            display: flex;

            // border: 1px solid #ccc;
            img {
                width: 60px;
                height: 60px;
                margin-right: 20px;
            }

            .wordWrapper {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                width: 160px;

                .title {
                    font-size: 24px;
                    color: #35434c;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-bottom: 10px;
                }

                .desc {
                    word-wrap: break-word;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;
                    overflow: hidden;
                    color: #c0c0c0;
                    font-size: 20px;
                }
            }
        }
    }

    .wordAndImage {
        >div {
            border: 0;
            align-items: center;
        }
    }

    :deep(.van-swipe) {
        padding-bottom: 100px;
    }

    :deep(.van-swipe__indicator) {
        width: 18px;
        height: 18px;
        background: #d9d9d9;
        border-radius: 50%;
    }

    :deep(.van-swipe__indicator--active) {
        width: 60px;
        height: 18px;
        background: linear-gradient(270deg, #62737e 0%, #333f48 100%);
        border-radius: 9px;
    }

    :deep(.van-swipe__indicator:not(:last-child)) {
        margin-right: 18px;
    }
</style>
